import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0fab0ab2")
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "label-option-desc" }, "SHAPE", -1)
const _hoisted_3 = { id: "shape-info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      "aria-label": "Open change shape modal",
      id: "label-shapes-btn",
      disabled: _ctx.isDisabledRef,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showLabelShapes && _ctx.showLabelShapes(...args)))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.currentLabel.shape_title) + " Labels ", 1),
        _hoisted_4
      ])
    ], 8, _hoisted_1)
  ]))
}